(()=>{
  if(window.tbFastCollectionsBound)return;
  window.tbFastCollectionsBound=true;
  document.addEventListener('change',event=>{
    const select=event.target.closest?.('[data-tbmm-sort]');
    if(!select||!select.querySelector('option[value=""]'))return;
    event.stopImmediatePropagation();
    const url=new URL(location.href);
    url.searchParams.delete('page');
    if(select.value)url.searchParams.set('sort_by',select.value);
    else url.searchParams.delete('sort_by');
    location.assign(url);
  },true);
  const init=()=>{
    const root=document.querySelector('[data-tb-fast-enabled="1"]');
    if(!root||root.dataset.tbFastBound)return;
    root.dataset.tbFastBound='1';
    const motion=root.dataset.tbFastDesign==='motion';
    const grid=root.querySelector(motion?'.product-grid-container':'.tbmm-grid');
    const status=root.querySelector('[data-tb-fast-status]');
    if(!grid||!status)return;
    const inlineCatalog=root.querySelector('[data-tb-fast-inline] [data-tb-fast-catalog]');
    const message=status.querySelector('[data-tb-fast-message]');
    const retry=status.querySelector('[data-tb-fast-retry]');
    const pageSize=Number(root.dataset.tbFastPageSize||root.querySelector('[data-tb-fast-page-size]')?.dataset.tbFastPageSize||24);
    const currentPage=Math.max(1,Number(root.dataset.tbFastPage)||1);
    const extras=[...grid.children].filter(el=>!el.matches('.tbmm-product-card,.grid-product'));
    let products=[],cursor=0,loadRoot,loadLink,loader,fallback,observer,running=false;
    const pageUrl=page=>{const url=new URL(location.href);url.searchParams.delete('section_id');url.searchParams.delete('sections');if(page>1)url.searchParams.set('page',String(page));else url.searchParams.delete('page');return url.pathname+url.search;};
    const getBatch=async page=>{
      const url=new URL(location.href);
      url.searchParams.delete('sections');
      url.searchParams.set('section_id',motion?'tb-fast-catalog-motion':'tb-fast-catalog');
      url.searchParams.set('sort_by','created-descending');
      url.searchParams.set('page',String(page));
      const abort=new AbortController(),timer=setTimeout(()=>abort.abort(),25000);
      try{
        let catalog=page===1?inlineCatalog:null;
        if(!catalog){
          const response=await fetch(url,{credentials:'same-origin',signal:abort.signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
          if(!response.ok)throw new Error('Collection request failed');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          catalog=doc.querySelector('[data-tb-fast-catalog]');
        }
        if(!catalog||Number(catalog.dataset.page)!==page)throw new Error('Incomplete collection response');
        const total=Number(catalog.dataset.total),pages=Number(catalog.dataset.pages);
        if(!Number.isInteger(total)||total<0||total>25000||pages>100)throw new Error('Collection exceeds the supported complete-result limit');
        const entries=[...catalog.querySelectorAll('template[data-tb-fast-product]')].map(template=>{
          const card=template.content.firstElementChild;
          const id=template.dataset.id,created=Number(template.dataset.created),fast=template.dataset.fast==='1';
          if(!id||!card||!Number.isFinite(created)||created<=0)throw new Error('Product information missing');
          card.dataset.tbFast=fast?'1':'0';
          card.dataset.tbCreated=String(created);
          card.dataset.tbProductId=id;
          card.dataset.tbProductHandle=template.dataset.handle;
          return {id,created,fast,card};
        });
        if(entries.length!==Math.max(0,Math.min(250,total-(page-1)*250)))throw new Error('Collection changed while loading');
        return {total,pages,entries,collection:catalog.dataset.collection};
      }finally{clearTimeout(timer);}
    };
    const prepareImages=(card,eager)=>{
      card.querySelectorAll('img').forEach(image=>{
        image.decoding='async';
        if(eager){image.loading='eager';image.setAttribute('fetchpriority','high');}
      });
      return card;
    };
    const warmFirstRow=async entries=>{
      await Promise.all(entries.slice(0,4).map(({card})=>{
        const source=card.querySelector('img');
        if(!source?.getAttribute('src'))return Promise.resolve();
        const image=new Image();
        image.decoding='async';
        image.setAttribute('fetchpriority','high');
        if(source.getAttribute('sizes'))image.sizes=source.getAttribute('sizes');
        if(source.getAttribute('srcset'))image.srcset=source.getAttribute('srcset');
        image.src=source.getAttribute('src');
        return new Promise(resolve=>{
          const timer=setTimeout(resolve,4000);
          image.decode().catch(()=>{}).finally(()=>{clearTimeout(timer);resolve();});
        });
      }));
    };
    const notify=cards=>{
      document.dispatchEvent(new CustomEvent('tbmm:products-appended',{detail:{cards,grid}}));
      document.dispatchEvent(new CustomEvent('tbfast:rendered',{detail:{grid}}));
      if(motion){window.AOS?.refreshHard?.();window.theme?.reinitProductGridItem?.(root);}
    };
    const updateNext=()=>{
      if(cursor>=products.length){
        observer?.disconnect();
        loadLink?.removeAttribute('href');
        if(loadRoot)loadRoot.hidden=true;
      }else{
        if(loadRoot)loadRoot.hidden=false;
        loadLink?.setAttribute('href',pageUrl(Math.floor(cursor/pageSize)+1));
      }
      if(loadRoot){
        loadRoot.dataset.loaded=String(cursor);
        const meta=loadRoot.querySelector('.tbmm-load-more__meta');
        if(meta)meta.textContent=cursor+' OF '+products.length+' SHOWN';
      }
      root.dataset.tbFastShown=String(grid.querySelectorAll('[data-tb-product-id]').length);
    };
    const append=()=>{
      if(root.dataset.tbFastState!=='ready'||cursor>=products.length)return;
      const fragment=document.createDocumentFragment(),cards=[];
      for(const entry of products.slice(cursor,cursor+pageSize)){const card=prepareImages(document.importNode(entry.card,true),cards.length<4);fragment.append(card);cards.push(card);}
      cursor+=cards.length;
      grid.querySelectorAll(':scope > .tbmm-editorial-endcap').forEach(el=>el.remove());
      grid.append(fragment);
      updateNext();notify(cards);
    };
    const setupPagination=()=>{
      root.querySelectorAll('[data-tbmm-load-more-root]').forEach(el=>el.remove());
      if(motion)root.querySelectorAll('.pagination').forEach(el=>el.remove());
      if(cursor>=products.length)return;
      loadRoot=document.createElement('div');
      loadRoot.className='tbmm-load-more-wrap';loadRoot.dataset.tbmmLoadMoreRoot='';loadRoot.dataset.total=String(products.length);loadRoot.setAttribute('aria-live','polite');
      loadLink=document.createElement('a');loadLink.className='tbmm-load-more';loadLink.dataset.tbmmLoadMore='';loadLink.textContent='LOAD MORE';
      const meta=document.createElement('div');meta.className='tbmm-load-more__meta';
      loadRoot.append(loadLink,meta);
      if(!motion){
        loader=document.createElement('div');loader.className='tbmm-infinite-loader is-idle';loader.setAttribute('aria-hidden','true');loader.innerHTML='<span></span><span></span><span></span>';
        fallback=document.createElement('button');fallback.type='button';fallback.className='tbmm-infinite-fallback';fallback.textContent='LOAD MORE';
        loadRoot.prepend(loader);loadRoot.append(fallback);
        fallback.addEventListener('click',append);
      }
      const anchor=motion?root.querySelector('#CollectionAjaxContent'):grid;
      anchor.after(loadRoot);
      loadLink.addEventListener('click',event=>{event.preventDefault();append();});
      updateNext();
      if(!motion){
        let scrollFrame=0;
        const nearBoundary=()=>{
          scrollFrame=0;
          if(!root.isConnected||root.dataset.tbFastState!=='ready'||cursor>=products.length)return;
          if(loadRoot.getBoundingClientRect().top<=innerHeight+140){append();scrollFrame=requestAnimationFrame(nearBoundary);}
        };
        const onScroll=()=>{if(!root.isConnected){window.removeEventListener('scroll',onScroll);return;}if(!scrollFrame)scrollFrame=requestAnimationFrame(nearBoundary);};
        window.addEventListener('scroll',onScroll,{passive:true});
        requestAnimationFrame(nearBoundary);
        observer=new IntersectionObserver(entries=>{
          if(entries.some(entry=>entry.isIntersecting)&&cursor<products.length){
            append();
            requestAnimationFrame(()=>{if(cursor<products.length){observer.unobserve(loadRoot);observer.observe(loadRoot);}});
          }
        },{rootMargin:'0px 0px 140px 0px',threshold:0.01});
        observer.observe(loadRoot);
      }
    };
    const load=async()=>{
      if(running)return;
      running=true;
      root.dataset.tbFastState='loading';root.setAttribute('aria-busy','true');
      retry.hidden=true;message.textContent='';
      observer?.disconnect();
      try{
        const first=await getBatch(1);
        const batches=[first],queue=Array.from({length:Math.max(0,first.pages-1)},(_,i)=>i+2);
        await Promise.all(Array.from({length:Math.min(3,queue.length)},async()=>{
          while(queue.length){
            const batch=await getBatch(queue.shift());
            if(batch.total!==first.total||batch.pages!==first.pages||batch.collection!==first.collection)throw new Error('Collection changed while loading');
            batches.push(batch);
          }
        }));
        const all=batches.flatMap(batch=>batch.entries);
        if(all.length!==first.total||new Set(all.map(entry=>entry.id)).size!==first.total)throw new Error('Collection changed while loading');
        products=all.sort((a,b)=>Number(b.fast)-Number(a.fast)||b.created-a.created||b.id.length-a.id.length||b.id.localeCompare(a.id));
        root.dataset.tbFastTotal=String(products.length);
        root.dataset.tbFastCount=String(products.filter(entry=>entry.fast).length);
        root.dataset.tbFastComplete='1';
        root.dataset.tbFastSource=inlineCatalog?'initial-page':'section-fetch';
        const oldOrder=root.querySelector('[data-tb-fast-order]');
        oldOrder?.remove();
        const order=document.createElement('script');order.type='application/json';order.dataset.tbFastOrder='';
        order.textContent=JSON.stringify(products.map(({id,created,fast})=>({id,created,fast})));root.append(order);
        const start=(currentPage-1)*pageSize;
        const selected=products.slice(start,start+pageSize);
        if(!inlineCatalog)await warmFirstRow(selected);
        const fragment=document.createDocumentFragment(),cards=[];
        selected.forEach((entry,index)=>{
          const card=prepareImages(document.importNode(entry.card,true),index<4);cards.push(card);fragment.append(card);
          if(!motion&&index===7)extras.filter(el=>el.matches('.tbmm-bestseller-spotlight,.tbmm-offer-card')).forEach(el=>fragment.append(el));
          if(!motion&&index===15)extras.filter(el=>el.matches('.tbmm-color-quick')).forEach(el=>fragment.append(el));
        });
        if(!selected.length){const empty=document.createElement('p');empty.textContent='No products found.';fragment.append(empty);}
        root.dataset.tbFastState='ready';root.removeAttribute('aria-busy');
        grid.replaceChildren(fragment);cursor=Math.min(start+selected.length,products.length);
        setupPagination();updateNext();notify(cards);
      }catch(error){
        root.dataset.tbFastState='error';root.removeAttribute('aria-busy');
        root.dataset.tbFastComplete='0';
        message.textContent='Products could not be loaded. Please try again or narrow your filters.';
        retry.hidden=false;
        console.warn('[TrenBee FAST sorting]',error);
      }finally{running=false;}
    };
    retry.addEventListener('click',load);
    load();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();